import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, putRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';

export const getOrganisation = async () => {
  const urlBuilder = createUrlBuilder('/organisation');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};

export const updateOrganisation = async (data: any) => {
  const urlBuilder = createUrlBuilder('/organisation');
  const result = await putRequest(LocateService, urlBuilder.toString(), data);
  return result;
};

export const invalidateOrganisationPermalink = async () => {
  const urlBuilder = createUrlBuilder('/organisation/permalink/invalidate');
  const result = await putRequest(LocateService, urlBuilder.toString(), {});
  return result;
};
